<template>
  <div class="image-function-page">
    <!-- 主面板 -->
    <div class="main-panel">
      <!-- 顶部操作栏 -->
      <div class="top-bar">
        <button class="btn-back" @click="goBack">
          <i class="fas fa-arrow-left"></i>
          <span>返回</span>
        </button>
        <div class="top-actions">
          <button class="action-btn select-all" @click="toggleSelectAll">
            <i :class="['fas', selectAll ? 'fa-check-square' : 'fa-square']"></i>
            <span>{{ selectAll ? '取消全选' : '全选' }}</span>
          </button>
          <button class="action-btn rewrite" @click="batchRewrite" v-if="talkType=='anchor' || talkType=='cohost'">
            <i class="fas fa-pencil-alt"></i>
            <span>批量改写</span>
          </button>
          <button class="action-btn variable" @click="batchVariable" v-if="talkType=='anchor' || talkType=='cohost'">
            <i class="fas fa-exchange-alt"></i>
            <span>批量变量</span>
          </button>
          <button class="action-btn primary" @click="addRow">
            <i class="fas fa-plus"></i>
            <span>新增一行</span>
          </button>
          <button class="action-btn import" @click="importData">
            <i class="fas fa-download"></i>
            <span>导入</span>
          </button>
          <button class="action-btn export" @click="exportData">
            <i class="fas fa-upload"></i>
            <span>导出</span>
          </button>
          <button class="action-btn danger" @click="batchDelete">
            <i class="fas fa-trash"></i>
            <span>批量删除</span>
          </button>
          <button class="action-btn save" @click="saveAll">
            <i class="fas fa-save"></i>
            <span>保存</span>
          </button>
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="content-panel">
        <div class="talks-list">
          <div
              v-for="(row, index) in talkRows"
              :key="row.index"
              class="talk-row" :class="{'talk-error':row.content.length>80}"
          >
            <!-- 第一行：复选框、选项、序号、操作按钮 -->
            <div class="row-header">
              <div class="row-checkbox">
                <input type="checkbox" v-model="selectedRows[row.index]">
              </div>
              <div class="row-actions">
                <button
                    class="row-btn rewrite"
                    @click="addRewrite(row)"
                    :disabled="row.rewrites && row.rewrites.length >= 5"
                    v-if="talkType=='anchor' || talkType=='cohost'"
                     >
                  <span>新增改写</span>
                </button>
                <button class="row-btn variable" @click="handleVariable(index)" v-if="talkType=='anchor' || talkType=='cohost'">
                  <span>话术变量</span>
                </button>
                <button class="row-btn play" @click="playContent(index)">
                  <span>试听</span>
                </button>
                <button class="row-btn delete" @click="deleteRow(index)">
                  <span>删除本行</span>
                </button>
              </div>
            </div>
            <!-- 第二行：序号和输入框 -->
            <div class="row-content" :style="{'align-items':(talkType=='keyword' ? 'start' : '')}" >
              <div class="row-number">{{ index + 1 }}</div>
              <div class="name-input-wrapper" v-if="talkType=='anchor' || talkType=='cohost' || talkType=='keyword'">
                <textarea v-if="talkType=='anchor' || talkType=='cohost'"
                    v-model="row.content"
                    class="name-input"
                    placeholder="话术内容"
                    rows="5"
                ></textarea>
                <textarea v-else-if="talkType=='keyword'"
                          v-model="row.keyword"
                          class="name-input"
                          placeholder="关键词"
                          rows="5"

                ></textarea>


              </div>
              <div class="content-input-wrapper">
                <!-- 当有改写时显示改写内容，否则显示话术内容 -->
                <template v-if="row.rewrites && row.rewrites.length > 0" >
                  <!-- 标题栏 -->
                  <div class="rewrites-header" @click="toggleRewrites(index)">
                    <span class="rewrites-title">改写内容 ({{ row.rewrites.length }})</span>
                    <i :class="['fas', row.rewritesExpanded ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                  </div>
                  <!-- 改写列表 -->
                  <div class="rewrites-list" >

                    <!-- 始终显示第一条 -->
                    <div v-for="(rewrite, rIndex) in row.rewrites" :key="rIndex" class="rewrite-item"
                         :style="{ display: rIndex === 0 || row.rewritesExpanded ? 'flex' : 'none' }">
                      <span class="rewrite-label">改写{{ rIndex + 1 }}:</span>
                      <div class="rewrite-input-wrapper">
                        <textarea
                            v-model="row.rewrites[rIndex]"
                            class="rewrite-input"
                            placeholder="改写内容"
                        ></textarea>
                        <!-- 变量按钮 - 只在关键词话术组显示 -->
                        <div v-if="showVariables" class="variables-bar">
                          <button class="variable-btn" @click="insertRewriteVariable(index, rIndex, '{名字}')">
                            名字变量
                          </button>
                          <button class="variable-btn" @click="insertRewriteVariable(index, rIndex, '{人数}')">
                            人数变量
                          </button>
                          <button class="variable-btn" @click="insertRewriteVariable(index, rIndex, '{时间}')">
                            时间变量
                          </button>
                        </div>
                      </div>
                      <button class="rewrite-btn variable" @click="handleVariable(index,rIndex)">
                        <span>话术变量</span>
                      </button>
                      <button class="rewrite-btn play" @click="playRewriteContent(index, rIndex)">
                        <span>试听</span>
                      </button>
                      <button class="rewrite-delete" @click="deleteRewrite(index, rIndex)">
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <textarea
                      v-model="row.content"
                      class="content-input"
                  ></textarea>

                  <!-- 变量按钮 - 只在关键词话术组显示 -->
                  <div v-if="showVariables" class="variables-bar">
                    <button class="variable-btn" @click="insertVariable(index, 'content', '{名字}')" v-if="talkType === 'keyword' || talkType === 'welcome'">名字变量</button>
                    <button class="variable-btn" @click="insertVariable(index, 'content', '{人数}')">人数变量</button>
                    <button class="variable-btn" @click="insertVariable(index, 'content', '{时间}')">时间变量</button>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gradioMod from "@/utils/gradio-index"
import http from "@/utils/http";
import {chat} from "@/utils/Ai";
import {getDouyinName, getYmdHm, randomText} from "@/utils/function";
let audioText



export default {
  name: 'ImageFunction',
  data() {
    return {
      currentAudio: null,
      talkRows: [],
      selectAll: false,
      selectedRows: {},
      talkType: '',
      talkId: null,
      voiceName: null,
      key: null
    }
  },
  computed: {
    showVariables() {
      // 如果没有指定话术组类型，默认显示变量
      // 只有明确指定非关键词话术组时才隐藏变量
      if (!this.talkType) {
        return true
      }
      return this.talkType === 'keyword' || this.talkType === 'timing' || this.talkType=='welcome'
    },
    apiKey(){
      return this.$store.state.apiKey;
    }
  },
  async mounted() {
    const mod = await gradioMod;
    ({  audioText } = mod);
    // 获取路由参数
    this.talkType = this.$route.query.type || ''
    this.talkId = this.$route.query.talkId;

    this.getKey();

    this.getList();

    this.getVoiceFind();

  },
  methods: {

    async getKey() {

      const res = await http.get("api/ai/getKey");
      if (res.code == 200) {
        this.$store.commit("setApiKey",res.data);
      }

    },

    async getList() {
      const list = await this.Db("话术列表").where("talk_type").where("talk_id", this.talkId).select();
      console.log(list)
      if (list.length <= 0) {
        this.talkRows = [{
          index: 1,
          content: '',
          rewrites: [],
        }]
      } else {
        this.talkRows = list;
      }
    },
    async getVoiceFind() {

      const data = await this.Db("音色配置").find();

      if (!data || !data?.anchor) {
        return;
      }
      this.voiceName = data.anchor;


    },
    goBack() {
      this.$router.push('/voice-reply')
    },
    toggleSelectAll() {
      this.selectAll = !this.selectAll
      this.talkRows.forEach(row => {
        this.$set(this.selectedRows, row.index, this.selectAll)
      })
    },
    insertVariable(rowIndex, field, variable) {
      const row = this.talkRows[rowIndex]
      console.log(row)
      row[field] = (row[field] || '') + variable
    },
    insertRewriteVariable(rowIndex, rewriteIndex, variable) {
      const row = this.talkRows[rowIndex]
      if (!row.rewrites) {
        row.rewrites = ['']
      }

      console.log(row.rewrites[rewriteIndex])
      row.rewrites[rewriteIndex] = (row.rewrites[rewriteIndex] || '') + variable
    },
    addRow() {
      const newId = this.talkRows.length > 0 ? Math.max(...this.talkRows.map(r => r.index)) + 1 : 1
      this.talkRows.push({
        index: newId,
        content: '',
        rewrites: [],
      })
    },

    async batchVariable(){
      this.talkRows.forEach(async (val,index) => {
        val.rewrites.forEach((v,rIndex)=>{
          this.handleVariable(index,rIndex);
        })
      })



    },


    async batchRewrite() {

      this.talkRows.forEach(async v => {
         this.addRewrite(v);
      })


      this.$dialog.tips({
        message:"操作完成",
      })



    },
    async addRewrite(data) {
      const row = data


      if (row.rewrites.length >= 5) {
        const index=this.talkRows.findIndex(item=>item.index==row.index);
        console.log(index);

        this.$dialog.tips({type: "error", message: `改写失败,第${index+1}已经5条了`})
        return ;
      }

      this.$dialog.loading({text: "改写中，请稍等..."})

      console.log(this.apiKey)
      this.$store.commit("setMessageList",[]);
      const res = await chat(this.$store.state.appids.rewrite_id, this.apiKey, row.content).catch((message)=>{
        this.$dialog.closeLoading();
        this.$dialog.alert({
          title:"温馨提示",
          message
        })
      });

      this.$dialog.closeLoading();

      if (res) {
        if (!row.rewrites) {
          this.$set(row, 'rewrites', [])
        }
        if (row.rewrites.length < 5) {
          row.rewrites.push(res)
          this.$set(row, 'rewritesExpanded', true)
        }
        return true;
      }


      return false;

    },
    toggleRewrites(index) {
      const row = this.talkRows[index]
      this.$set(row, 'rewritesExpanded', !row.rewritesExpanded)
    },
    deleteRewrite(rowIndex, rewriteIndex) {
      this.talkRows[rowIndex].rewrites.splice(rewriteIndex, 1)
    },

    async playRewriteContent(rowIndex, rewriteIndex) {
      // 试听改写内容功能

      var  content = this.talkRows[rowIndex].rewrites[rewriteIndex]
      if (content) {
        if (!this.voiceName) {
          this.$dialog.tips({
            type: "error",
            message: "未设置主播音色!"
          })
          return;
        }
        content=randomText(content);

        this.$dialog.loading({text: "音频生成中..."});
        console.log(content)
        const blob = await audioText(content, this.voiceName);
        const audio=new Audio(blob);


        this.$dialog.closeLoading();
        this.stopAudio();
        this.currentAudio = audio;
        audio.play(); // 直接播放！

      } else {
        this.$dialog.tips({message: "没有输入改写内容.", type: "error"})
      }
    },
    deleteRow(index) {
      if (this.talkRows.length > 1) {
        this.talkRows.splice(index, 1)

        return;
      }
      this.$dialog.tips({
        type: "info",
        message: "至少保留一行"
      })
    },
    async batchDelete() {
      const selectedIds = Object.keys(this.selectedRows).filter(index => this.selectedRows[index])
      if (selectedIds.length === 0) {
        this.$dialog.tips({
          message: "请先选择要删除的行",
          type: "error"
        })
        return
      }
      if (this.talkRows.length - selectedIds.length < 1) {
        this.$dialog.tips({
          message: "至少保留一行",
          type: "error"
        })
        return
      }

      const confirm = await this.$dialog.confirm({
        title: "温馨提示",
        message: `确定删除选中的 ${selectedIds.length} 行吗？`,
        okText: "删除",
        cancelText: "取消"
      }).catch(() => false);

      if (confirm !== false) {
        this.talkRows = this.talkRows.filter(row => !this.selectedRows[row.index])
        this.selectedRows = {}
        this.selectAll = false
      }


    },
    importData() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.txt,.json'
      input.onchange = (e) => {
        const file = e.target.files[0]


        if (file) {
          const reader = new FileReader()
          reader.onload = (event) => {
            try {
              var data = event.target.result;

              console.log(file.type)

              if (file.type == 'text/plain') {
                data = data.split("\r\n");
                if (Array.isArray(data)) {
                  this.talkRows = [];
                  data.forEach((item, key) => {
                    if (item.length > 80) {
                      this.$dialog.tips({message: `第${key + 1}行超出80字`, type: "error"})
                    }
                    this.talkRows.push({
                      index: key + 1,
                      content: item || '',
                      rewrites: [],

                    })
                  });
                  this.$dialog.tips({message: "导入成功", type: "success"})
                } else {
                  this.$dialog.tips({message: "格式不正确", type: "error"})
                }

              } else {
                const datas=JSON.parse(data);

                this.talkRows=datas.map(item=>{
                  delete item?.id;
                  return item;
                })

                this.$dialog.tips({message: "导入成功", type: "success"})
              }
            } catch (error) {
              this.$dialog.tips({message: "导入失败", type: "error"})
            }
          }
          reader.readAsText(file)
        }
      }
      input.click()
    },
    exportData() {
      const dataStr = JSON.stringify(this.talkRows, null, 2)
      const blob = new Blob([dataStr], {type: 'application/json'})
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'talk_data_' + new Date().getTime() + '.json'
      link.click()
      URL.revokeObjectURL(url)
      alert('导出成功')
    },
    async playContent(index) {


      var content = this.talkRows[index].content

      if (content) {
        if (!this.voiceName) {
          this.$dialog.tips({
            type: "error",
            message: "未设置主播音色!"
          })
          return;
        }


        content=randomText(content);

        content=content.replaceAll("{人数}",Math.floor(Math.random() * 100)).replaceAll("{时间}",getYmdHm()).replaceAll("{名字}",getDouyinName);

        this.$dialog.loading({text: "音频生成中..."});
        const blob = await audioText(content, this.voiceName);

        this.$dialog.closeLoading();

        if(blob){
          const audio=new Audio(blob);
          console.log(audio)
          this.stopAudio();
          this.currentAudio = audio;
          audio.play(); // 直接播放！


        }


      }
    },
    stopAudio() {
      if (this.currentAudio) {
        this.currentAudio.pause();
        this.currentAudio = null;
      }

    },
    handleRewrite(index) {
      alert(`已为第${index + 1}行新增改写`)
    },

    hasBracket(text) {
      return /【|】/.test(text);
    },
    async handleVariable(index,rIndex=null) {



      var content="";
      if(rIndex!==null){
        var content=this.talkRows[index].rewrites[rIndex];
      }else{
        var content=this.talkRows[index].content
      }


      if(this.hasBracket(content)){
        return;
      }



      if(!content){

        this.$dialog.tips({
          message:"内容不能为空",
          type:"error"
        })
        return;
      }

      this.$dialog.loading({text: "增加变量中，请稍等..."})
      this.$store.commit("setMessageList",[]);

      const res=await chat(this.$store.state.appids.var_id, this.apiKey,content).catch((message)=>{
        this.$dialog.closeLoading();
        this.$dialog.alert({
          title:"温馨提示",
          message
        })
      });
      this.$dialog.closeLoading();
      if(res){
        if(rIndex!==null){
          this.$set(this.talkRows[index].rewrites, rIndex, res)
        }else{
          this.talkRows[index].content=res;

        }

        this.$dialog.tips({
          message:`已为您提供变量`
        })
      }

    },
    async saveAll() {



      const res=await this.Db("话术列表").where("talk_id",this.talkId).delete();



      this.talkRows.forEach(async v => {
        v.talk_id = this.talkId
        v.talk_type = this.talkType;
        console.log(v);
        await this.Db("话术列表").add(v);
      })

      this.$dialog.tips({
        message:"保存成功"
      })


    }
  }
}
</script>

<style scoped>
.image-function-page {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.main-panel {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
  padding: 25px;
  position: relative;
  overflow: hidden;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(170, 170, 170, 0.2);
  margin-bottom: 20px;
}

.btn-back {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: 1px solid rgba(100, 116, 139, 0.5);
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(71, 85, 105, 0.6) 0%, rgba(45, 55, 72, 0.6) 100%);
  color: #cbd5e1;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-back:hover {
  background: linear-gradient(135deg, rgba(71, 85, 105, 0.7) 0%, rgba(45, 55, 72, 0.7) 100%);
  border-color: rgba(100, 116, 139, 0.7);
}

.top-actions {
  display: flex;
  gap: 12px;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  border: 1px solid rgba(120, 120, 120, 0.5);
  border-radius: 10px;
  background: rgba(120, 120, 120, 0.35);
  color: rgba(200, 200, 200, 0.95);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-btn:hover {
  border-color: rgba(150, 150, 150, 0.7);
}

.action-btn.select-all {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.4) 0%, rgba(63, 66, 244, 0.4) 100%);
  color: #a5b4fc;
  border-color: rgba(129, 140, 248, 0.5);
}

.action-btn.select-all:hover {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.5) 0%, rgba(63, 66, 244, 0.5) 100%);
  border-color: rgba(129, 140, 248, 0.7);
}

.action-btn.rewrite {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.4) 0%, rgba(34, 197, 94, 0.4) 100%);
  color: #6ee7b7;
  border-color: rgba(74, 222, 128, 0.5);
}

.action-btn.rewrite:hover {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.5) 0%, rgba(34, 197, 94, 0.5) 100%);
  border-color: rgba(74, 222, 128, 0.7);
}

.action-btn.variable {
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.4) 0%, rgba(234, 88, 12, 0.4) 100%);
  color: #fcd34d;
  border-color: rgba(251, 191, 36, 0.5);
}

.action-btn.variable:hover {
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.5) 0%, rgba(234, 88, 12, 0.5) 100%);
  border-color: rgba(251, 191, 36, 0.7);
}

.action-btn.primary {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.5) 0%, rgba(99, 102, 241, 0.5) 100%);
  color: #c4b5fd;
  border-color: rgba(167, 139, 250, 0.6);
}

.action-btn.primary:hover {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.6) 0%, rgba(99, 102, 241, 0.6) 100%);
  border-color: rgba(167, 139, 250, 0.8);
}

.action-btn.import {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.4) 0%, rgba(37, 99, 235, 0.4) 100%);
  color: #93c5fd;
  border-color: rgba(147, 197, 253, 0.5);
}

.action-btn.import:hover {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.5) 0%, rgba(37, 99, 235, 0.5) 100%);
  border-color: rgba(147, 197, 253, 0.7);
}

.action-btn.export {
  background: linear-gradient(135deg, rgba(168, 85, 247, 0.4) 0%, rgba(139, 92, 246, 0.4) 100%);
  color: #e9d5ff;
  border-color: rgba(192, 132, 252, 0.5);
}

.action-btn.export:hover {
  background: linear-gradient(135deg, rgba(168, 85, 247, 0.5) 0%, rgba(139, 92, 246, 0.5) 100%);
  border-color: rgba(192, 132, 252, 0.7);
}

.action-btn.danger {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.4) 0%, rgba(220, 38, 38, 0.4) 100%);
  color: #fca5a5;
  border-color: rgba(248, 113, 113, 0.5);
}

.action-btn.danger:hover {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.5) 0%, rgba(220, 38, 38, 0.5) 100%);
  border-color: rgba(248, 113, 113, 0.7);
}

.action-btn.save {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.5) 0%, rgba(34, 197, 94, 0.5) 100%);
  color: #34d399;
  border-color: rgba(34, 197, 94, 0.6);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);
}

.action-btn.save:hover {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.6) 0%, rgba(34, 197, 94, 0.6) 100%);
  border-color: rgba(34, 197, 94, 0.8);
}

.content-panel {
  min-height: 400px;
}

.talks-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 550px;
  overflow: hidden;
  overflow-y: auto;
}

.talk-row {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  box-shadow: 0 4px 20px rgba(170, 170, 170, 0.1);
}

.talk-error {
  border: 1px solid rgb(255, 0, 0);

}

.row-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(170, 170, 170, 0.15);
}

.row-checkbox {
  flex-shrink: 0;
}

.row-checkbox input {
  width: 18px;
  height: 18px;
  cursor: pointer;
}


.row-actions {
  display: flex;
  gap: 10px;
}

.row-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 16px;
  border: 1px solid rgba(170, 170, 170, 0.35);
  border-radius: 8px;
  background: rgba(170, 170, 170, 0.25);
  color: rgba(170, 170, 170, 0.95);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.row-btn:hover {
  background: rgba(170, 170, 170, 0.35);
  border-color: rgba(170, 170, 170, 0.5);
}

.row-btn.rewrite {
  border-color: rgba(16, 185, 129, 0.5);
  color: #34d399;
  background: rgba(16, 185, 129, 0.2);
}

.row-btn.rewrite:hover {
  background: rgba(16, 185, 129, 0.35);
  border-color: rgba(16, 185, 129, 0.7);
}

.row-btn.variable {
  border-color: rgba(139, 92, 246, 0.5);
  color: #c4b5fd;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(99, 102, 241, 0.3) 100%);
}

.row-btn.variable:hover {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.4) 0%, rgba(99, 102, 241, 0.4) 100%);
  border-color: rgba(139, 92, 246, 0.7);
}

.row-btn.play {
  border-color: rgba(34, 211, 238, 0.4);
  color: #67e8f9;
  background: rgba(34, 211, 238, 0.1);
}

.row-btn.play:hover {
  background: rgba(34, 211, 238, 0.25);
  border-color: rgba(34, 211, 238, 0.6);
}

.row-btn.delete {
  border-color: rgba(239, 68, 68, 0.4);
  color: #f87171;
  background: rgba(239, 68, 68, 0.1);
}

.row-btn.delete:hover {
  background: rgba(239, 68, 68, 0.25);
  border-color: rgba(239, 68, 68, 0.6);
}

.row-content {
  display: flex;
  align-items: center;
  gap: 15px;
}

.row-number {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(170, 170, 170, 0.2);
  border-radius: 8px;
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
  border: 1px solid rgba(170, 170, 170, 0.3);
}

.name-input-wrapper {
  width: 280px;
  flex-shrink: 0;
}

.name-input {
  width: 100%;
  height: 100px;
  padding: 12px 15px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 10px;
  background: rgba(30, 30, 30, 0.9);
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
  resize: none;
}

.name-input:focus {
  border-color: rgba(170, 170, 170, 0.5);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.15);
}

.name-input::placeholder {
  color: rgba(170, 170, 170, 0.4);
}

.content-input-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.content-input {
  width: 100%;
  height: 100px;
  padding: 12px 15px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 10px;
  background: rgba(30, 30, 30, 0.9);
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  resize: none;
  outline: none;
  transition: all 0.3s ease;
}

.content-input:focus {
  border-color: rgba(170, 170, 170, 0.5);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.15);
}

.content-input::placeholder {
  color: rgba(170, 170, 170, 0.4);
}

.rewrites-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: rgba(170, 170, 170, 0.15);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(170, 170, 170, 0.2);
}

.rewrites-header:hover {
  background: rgba(170, 170, 170, 0.2);
}

.rewrites-title {
  font-size: 13px;
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
}

.rewrites-header i {
  font-size: 14px;
  color: rgba(170, 170, 170, 0.7);
  transition: transform 0.3s ease;
}

.rewrites-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 5px;
  padding: 5px;
}

.rewrite-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px;
  background: rgba(35, 35, 35, 0.9);
  border-radius: 8px;
  border-left: 3px solid rgba(170, 170, 170, 0.4);
  border: 1px solid rgba(170, 170, 170, 0.15);
}

.rewrite-label {
  font-size: 12px;
  color: rgba(170, 170, 170, 0.7);
  font-weight: bold;
  min-width: 50px;
  padding-top: 6px;
}

.rewrite-input-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.rewrite-input {
  width: 100%;
  height: 60px;
  padding: 8px 12px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 6px;
  background: rgba(30, 30, 30, 0.9);
  color: rgba(170, 170, 170, 0.9);
  font-size: 13px;
  resize: none;
  outline: none;
  transition: all 0.3s ease;
}

.rewrite-input:focus {
  border-color: rgba(170, 170, 170, 0.5);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.15);
}

.rewrite-btn {
  padding: 6px 12px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 6px;
  background: rgba(170, 170, 170, 0.1);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 6px;
  color: rgba(170, 170, 170, 0.9);
}

.rewrite-btn.variable {
  border-color: rgba(170, 170, 170, 0.35);
  color: rgba(170, 170, 170, 0.9);
  background: rgba(170, 170, 170, 0.15);
}

.rewrite-btn.variable:hover {
  background: rgba(170, 170, 170, 0.25);
}

.rewrite-btn.play {
  border-color: rgba(34, 211, 238, 0.4);
  color: #67e8f9;
  background: rgba(34, 211, 238, 0.1);
}

.rewrite-btn.play:hover {
  background: rgba(34, 211, 238, 0.25);
}

.rewrite-delete {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: rgba(239, 68, 68, 0.3);
  color: #f87171;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 6px;
  transition: all 0.3s ease;
}

.rewrite-delete:hover {
  background: rgba(239, 68, 68, 0.5);
}

.row-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.variables-bar {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.variable-btn {
  padding: 4px 10px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 4px;
  background: rgba(170, 170, 170, 0.15);
  color: rgba(170, 170, 170, 0.9);
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.variable-btn:hover {
  background: rgba(170, 170, 170, 0.25);
  border-color: rgba(170, 170, 170, 0.5);
}
</style>
